import { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import Public from './Public';

// /rs route — Serbian audience. For now we render the same Public form
// using HR copy + samples (Serbian and Croatian audiences understand each
// other). Once Amine provides Serbian audio samples and any RS-specific
// translations, swap them in. We force lang to 'hr' so the t3() calls in
// Public.js fall through to the Croatian translation.
export default function SerbianPublic() {
  const { setLang } = useLanguage();

  useEffect(() => {
    setLang('hr');
  }, [setLang]);

  return <Public />;
}
